import { useTranslation } from 'react-i18next';
import { Link, generatePath } from 'react-router-dom';

import Folder from '@/icons/folder.svg';
import Background from '@/icons/union.svg';
import routes from '@/routes';
import { DATE_FORMAT_TYPES, formatDate } from '@/utils';

import DropdownMenuItem from './DropdownMenuItem';

function ListItem({ item }) {
	const { t } = useTranslation();

	return (
		<li className="relative">
			<Link
				aria-label={t('myDocuments.folders.goToFolder', {
					folderName: item.name
				})}
				className="group relative block h-auto w-auto focus-visible:outline-none"
				to={generatePath(routes.folder, { id: item.id })}
			>
				<Background
					aria-hidden="true"
					className="absolute z-[-1] text-grey-200"
				/>
				<div
					key={item.name}
					className="flex w-[212px] flex-col gap-1 px-4 py-3"
				>
					<div className="flex justify-between">
						<Folder className="text-red" />
					</div>
					<span className="text-xs font-semibold leading-5">
						{item.name}
					</span>
					<span className="text-[10px] font-normal leading-4">
						{`${item.transactions} docs | ${formatDate(item.createdAt, DATE_FORMAT_TYPES.SHORT)}`}
					</span>
				</div>
			</Link>
			<div className="absolute right-2 top-3">
				<DropdownMenuItem item={item} />
			</div>
		</li>
	);
}

export default ListItem;
